import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AuthService } from '../../../../Shared/Services/auth.service';
import { HOME_DESTINATIONS, HOME_LAUNCHER_KEYS } from '../../../Consts/home-destinations.const';
import { HOME_LAUNCHER_LIMIT } from '../../../Consts/home.const';
import { HomeDestination } from '../../../Interfaces/home-destination.interface';
import { isHomeDestinationVisible } from '../../../Utils/home-destination.utils';

@Component({
  selector: 'app-home-launcher',
  standalone: true,
  imports: [COMMON_IMPORTS],
  templateUrl: './home-launcher.component.html',
  styleUrl: './home-launcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeLauncherComponent {
  private readonly _authService = inject(AuthService);
  private readonly _user = toSignal(this._authService.currentUser$, { initialValue: null });

  readonly items = computed<HomeDestination[]>(() => this.buildItems());

  readonly hasItems = computed(() => this.items().length > 0);

  private buildItems(): HomeDestination[] {
    const user = this._user();

    return HOME_LAUNCHER_KEYS.map(key => HOME_DESTINATIONS.find(destination => destination.key === key))
      .filter((destination): destination is HomeDestination => destination !== undefined)
      .filter(destination => isHomeDestinationVisible(destination, user))
      .slice(0, HOME_LAUNCHER_LIMIT);
  }
}
